module.exports = __webpack_public_path__ + "static/media/filter-dirty-dark.f6af56f4.svg";